import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import * as api from "../../api";

// Async Thunks
export const sendMessage = createAsyncThunk(
    "chat/sendMessage",
    async (chatData, { rejectWithValue }) => {
        try {
            const response = await api.sendChatMessage(chatData);
            return response;
        } catch (error) {
            return rejectWithValue(
                error.error || "Failed to connect to AI assistant."
            );
        }
    }
);

export const fetchChatHistory = createAsyncThunk(
    "chat/fetchChatHistory",
    async (sessionId, { rejectWithValue }) => {
        try {
            const response = await api.getChatHistory(sessionId);
            return response;
        } catch (error) {
            return rejectWithValue(error.error || "Failed to fetch chat history");
        }
    }
);

export const clearChat = createAsyncThunk(
    "chat/clearChat",
    async (sessionId, { rejectWithValue }) => {
        try {
            await api.clearChatHistory(sessionId);
            return true;
        } catch (error) {
            return rejectWithValue(error.error || "Failed to clear chat");
        }
    }
);

const chatSlice = createSlice({
    name: "chat",
    initialState: {
        messages: [],
        loading: false,
        error: null,
    },
    reducers: {
        addMessageLocally: (state, action) => {
            state.messages.push(action.payload);
        },
        resetChatState: (state) => {
            state.messages = [];
            state.error = null;
        },
    },
    extraReducers: (builder) => {
        builder
            // Fetch History
            .addCase(fetchChatHistory.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchChatHistory.fulfilled, (state, action) => {
                state.loading = false;
                state.messages = action.payload;
            })
            .addCase(fetchChatHistory.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            // Send Message
            .addCase(sendMessage.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(sendMessage.fulfilled, (state, action) => {
                state.loading = false;
                state.messages.push({
                    role: "assistant",
                    content: action.payload.message,
                    createdAt: action.payload.createdAt,
                });
            })
            .addCase(sendMessage.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
                // Optionally append an error message directly to display to the user
                state.messages.push({
                    role: "assistant",
                    content: `Error: ${action.payload}`,
                    isError: true,
                    createdAt: new Date().toISOString(),
                });
            })
            // Clear Chat
            .addCase(clearChat.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(clearChat.fulfilled, (state) => {
                state.loading = false;
                state.messages = [];
            })
            .addCase(clearChat.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    },
});

export const { addMessageLocally, resetChatState } = chatSlice.actions;

export default chatSlice.reducer;
